import { Account } from '@syf-api-library/credit-accounts'

const findAccount = (accounts: Account[], accountId: string): Account =>
  accounts.find(
    (account: Account) => account.info['cipher.accountId'] === accountId
  )

export default findAccount
